<template>
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <template v-if="menucustomers === true">
                <li class="removeActive" id="menucustomers">
                <router-link v-bind:to="{name: 'ListCustomer'}" title="Customer"><span class="fa-stack fa-lg pull-left"><i class="fa fa-users fa-stack-1x "></i></span>Customer</router-link>
                </li>
            </template>
            <template v-if="menucontacts === true">
                <li class="removeActive" id="menucontacts">
                <router-link v-bind:to="{name: 'ListContacts'}" title="Contact"><span class="fa-stack fa-lg pull-left"><i class="fa fa-id-card-o fa-stack-1x "></i></span>Contact</router-link>
                </li>
            </template>
            <template v-if="menutasks === true">
                <li class="removeActive" id="menutasks">
                <router-link v-bind:to="{name: 'ShowTask'}" title="Task"><span class="fa-stack fa-lg pull-left"><i class="fa fa-tasks fa-stack-1x "></i></span>Task</router-link>
                </li>
            </template>

            <!-- <template v-if="menuresale === true">
                <li class="removeActive" id="menuresale">
                <router-link v-bind:to="{name: 'ShowResale'}" title="Resale"><span class="fa-stack fa-lg pull-left"><i class="fa fa-exchange fa-stack-1x "></i></span>Resale</router-link>
                </li>
            </template> -->

            <!-- <template v-if="menuresalereason === true">
                <li class="removeActive" id="menuresalereason">
                <router-link v-bind:to="{name: 'ShowResaleReason'}" title="Resale Reason"><span class="fa-stack fa-lg pull-left"><i class="fa fa-cog fa-stack-1x "></i></span>Resale Reason</router-link>
                </li>
            </template> -->


            <template v-if="menucalls === true">
                <li class="removeActive" id="menucalls">
                <router-link v-bind:to="{name: 'ListCall'}" title="Calls/Email"><span class="fa-stack fa-lg pull-left"><i class="fa fa-address-book fa-stack-1x "></i></span>Calls/Email</router-link>
                </li>
            </template>
            <template v-if="menucases === true">
                <li class="removeActive" id="menucases">
                <router-link v-bind:to="{name: 'CaseList'}" title="Case"><span class="fa-stack fa-lg pull-left"><i class="fa fa-briefcase fa-stack-1x "></i></span>Case</router-link>
                </li>
            </template>
            <template v-if="menudunningnotices === true">
                <li class="removeActive" id="menudunningnotice">
                <router-link v-bind:to="{name: 'ListDunningNotices'}" title="Over Due"><span class="fa-stack fa-lg pull-left"><i class="fa fa-chain-broken fa-stack-1x "></i></span>Over Due</router-link>
                </li>
            </template>
            <!-- <template v-if="menuwelcomeletter === true">
                <li class="removeActive" id="menuwelcomeletter">
                <router-link v-bind:to="{name: 'WelcomeCustomers'}" title="Welcome Letter"><span class="fa-stack fa-lg pull-left"><i class="fa fa-file-text-o fa-stack-1x "></i></span>Welcome Letter</router-link>
                </li>
            </template> -->
            <template v-if="menuemployee === true">
                <li class="removeActive" id="menuemployee">
                <router-link v-bind:to="{name: 'ListEmployee'}" title="Employee"><span class="fa-stack fa-lg pull-left"><i class="fa fa-user fa-stack-1x "></i></span>Employee</router-link>
                </li>
            </template>
            <template v-if="menucollector === true">
                <li class="removeActive" id="menucollector">
                <router-link v-bind:to="{name: 'ListCollector'}" title="Collector"><span class="fa-stack fa-lg pull-left"><i class="fa fa-handshake-o fa-stack-1x "></i></span>Collector</router-link>
                </li>
            </template>
            <template v-if="menujob === true">
                <li class="removeActive" id="menujob">
                <router-link v-bind:to="{name: 'ListJobs'}" title="Jobs"><span class="fa-stack fa-lg pull-left"><i class="fa fa-cloud fa-stack-1x "></i></span>Jobs</router-link>
                </li>
            </template>
            <template v-if="menuemail === true">
                <li class="removeActive" id="menuemail">
                <router-link v-bind:to="{name: 'ListEmails'}" title="Email History"><span class="fa-stack fa-lg pull-left"><i class="fa fa-envelope fa-stack-1x "></i></span>Email History</router-link>
                </li>
            </template>
            <template v-if="menubusinessunits === true">
                <li class="removeActive" id="menubusinessunits">
                <router-link v-bind:to="{name: 'ListBusinessUnits'}" title="Business Units"><span class="fa-stack fa-lg pull-left"><i class="fa fa-archive fa-stack-1x "></i></span>Business Units</router-link>
                </li>
            </template>
            <template v-if="menurole === true">
                <li class="removeActive" id="menurole">
                <router-link v-bind:to="{name: 'ListRole'}" title="Role"><span class="fa-stack fa-lg pull-left"><i class="fa fa-user-circle-o fa-stack-1x "></i></span>Role</router-link>
                </li>
            </template>
            <template v-if="menucontactrequest === true">
                <li class="removeActive" id="menucontactrequest">
                <router-link v-bind:to="{name: 'ContactRequestList'}" title="Contact Requests"><span class="fa-stack fa-lg pull-left"><i class="fa fa-address-card-o fa-stack-1x "></i></span>Contact Requests</router-link>
                </li>
            </template>
            <template v-if="menuemailbounce === true">
                <li class="removeActive" id="menuemailbounce">
                <router-link v-bind:to="{name: 'EmailBounceList'}" title="Email Bounce"><span class="fa-stack fa-lg pull-left"><i class="fa fa fa-ban fa-stack-1x "></i></span>Email Bounce</router-link>
                </li>
            </template>
            <template v-if="menucustomersummary === true">
                <li class="removeActive" id="menucustomersummary">
                    <router-link v-bind:to="{name: 'ListCustomerSummary'}" title="Customer Summary"><span class="fa-stack fa-lg pull-left"><i class="fa fa-list-alt fa-stack-1x" aria-hidden="true"></i></span>Customer Credit Limits Review</router-link>
                </li>
            </template>
            <template v-if="menucustomersummarydoc === true">
                <li class="removeActive" id="menucustomersummarydoc">
                    <router-link v-bind:to="{name: 'ListCustomerSummaryDocs'}" title="Customer Summary Doc"><span class="fa-stack fa-lg pull-left"><i class="fa fa-file-o fa-stack-1x" aria-hidden="true"></i></span>Customer Summary Docs</router-link>
                </li>
            </template>
        </ul>
    </div>
    <!-- <aside id="leftsidebar" class="sidebar">
        <div class="menu">
            <ul class="list sidemenu">
                <template v-if="menucustomers === true">
                    <li>
                    <router-link v-bind:to="{ path:'/listcustomer'}" href="#" id="menucustomers" class='removeActive'><i class="material-icons" title="Customer">group</i><span>Customer</span></router-link>
                    </li>
                </template>
                <template v-if="menucontacts === true">
                    <li>
                    <router-link v-bind:to="{ path:'/listcontacts'}" href="#" id="menucontacts" class='removeActive'><i class="material-icons" title="Contact">account_box</i><span>Contact</span></router-link>
                    </li>
                </template>
                <template v-if="menutasks === true">
                    <li>
                    <router-link v-bind:to="{ path:'/task/list'}" href="#" id="menutasks" class='removeActive'><i class="material-icons" title="Task">assignment</i><span>Task</span></router-link>
                    </li>
                </template>
                <template v-if="menucalls === true">
                    <li>
                    <router-link v-bind:to="{ path:'/listcall'}" href="#" id="menucalls" class='removeActive'><i class="material-icons" title="Calls/Email">perm_phone_msg</i><span>Calls/Email</span></router-link>
                    </li>
                </template>
                <template v-if="menucases === true">
                    <li>
                    <router-link v-bind:to="{ path:'/case/list'}" href="#" id="menucases" class='removeActive'><i class="material-icons" title="Case">assignment_late</i><span>Case</span></router-link>
                    </li>
                </template>
                <template v-if="menudunningnotices === true">
                    <li>
                    <router-link v-bind:to="{ path:'/customer/dunningnotices'}" href="#" id="menudunningnotice" class='removeActive'><i class="material-icons" title="Dunning Notices">receipt</i><span>Dunning Notices</span></router-link>
                    </li>
                </template>
                <template v-if="menuwelcomeletter === true">
                    <li>
                    <router-link v-bind:to="{ path:'/list/welcomecustomers'}" href="#" id="menuwelcomeletter" class='removeActive'><i class="material-icons" title="Welcome Letter">description</i><span>Welcome Letter</span></router-link>
                    </li>
                </template>
                <template v-if="menuemployee === true">
                    <li>
                    <router-link v-bind:to="{ path:'/listemployee'}" href="#" id="menuemployee" class='removeActive'><i class="material-icons" title="Employee">perm_identity</i><span>Employee</span></router-link>
                    </li>
                </template>
                <template v-if="menujob === true">
                    <li>
                    <router-link v-bind:to="{ path:'/listjobs'}" href="#" id="menujob" class='removeActive'><i class="material-icons" title="Jobs">cloud_queue</i><span>Jobs</span></router-link>
                    </li>
                </template>
                <template v-if="menuemail === true">
                    <li>
                    <router-link v-bind:to="{ path:'/listemails'}" href="#" id="menuemail" class='removeActive'><i class="material-icons" title="Email History">email</i><span>Email History</span></router-link>
                    </li>
                </template>
                <template v-if="menubusinessunits === true">
                    <li>
                    <router-link v-bind:to="{ path:'/listbusinessunits'}" href="#" id="menubusinessunits" class='removeActive'><i class="material-icons" title="Business Units">business_center</i><span>Business Units</span></router-link>
                    </li>
                </template>
                <template v-if="menurole === true">
                    <li>
                    <router-link v-bind:to="{ path:'/listrole'}" href="#" id="menurole" class='removeActive'><i class="material-icons" title="Role">face</i><span>Role</span></router-link>
                    </li>
                </template>
                <template v-if="menucontactrequest === true">
                    <li>
                    <router-link v-bind:to="{ path:'/contact_request/list'}" href="#" id="menucontactrequest" class='removeActive'><i class="material-icons" title="Contact Requests" >note_add</i><span>Contact Requests</span></router-link>
                    </li>
                </template>
            </ul>
        </div>
    </aside> -->
</template>
<script>
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: 'FrontHome',
        mixins: [SessioMixin],
        data: () => ({
                isLoggedIn: false,
                firstName: "No",
                lastName: " Name",
                userName: "",
                permissions: [],
                menucustomers: true,
                menucontacts: true,
                menutasks: true,
                menuresale: true,
                menuresalereason: true,
                menucalls: true,
                menucases: true,
                menudunningnotices: true,
                menudunningnotice: true,
                menuwelcomeletter: true,
                menuemployee: true,
                menucollector: true,
                menujob: true,
                menuemail: true,
                menubusinessunits: true,
                menurole: true,
                menucontactrequest: true,
                menuemailbounce: true,
                menucustomersummary : true,
                menucustomersummarydoc : true,
            }),
        beforeMount: function () {
            var app = this;
            //console.log('menu beforeMount');
            var check = window.localStorage.getItem('api_token');
            if (!check) {
                app.$router.push({path: '/login'});
            } else {
                // get loggedin obj
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    var userJson = JSON.parse(userObj);
                    app.loggedinUserId = userJson.id;
                    app.firstName = userJson.first_name;
                    app.lastName = userJson.last_name;
                    app.userName = userJson.username;
                }
                app.getPermissions();
            }
        },
        mounted: function () {
            //console.log('menu mounted');
            /*$('#menu-open').hide();
             setTimeout(function() {
             if($('body').hasClass("overlay-open")){
             $('.bars').click();
             }
             }, 500);*/
            $(document).ready(function () {
                var viewportWidth = $(window).width();
                //console.log(viewportWidth);
                var menu_class = "";
                $(".app-sidebar-right").removeClass("toggled");
                $(".app-sidebar-right").removeClass("toggled-2");
                if (viewportWidth <= 667) {
                    if (localStorage.getItem("menu_small") == '1') {
                        $(".app-sidebar-right").removeClass('toggled');
                        $(".app-sidebar-right").removeClass('toggled-2');
                    }
                } else {
                    if (localStorage.getItem("menu_small") == '1') {
                        $(".app-sidebar-right").removeClass('toggled-2');
                        $(".app-sidebar-right").addClass('toggled-2');
                        $(".app-sidebar-right").removeClass('toggled');
                    }
                }
            });
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                if (localStorage.getItem("menu_small") == '1') {
                    window.localStorage.setItem("menu_small", '0');
                    $(".app-sidebar-right").addClass("toggled");
                } else {
                    window.localStorage.setItem("menu_small", '1');
                    $(".app-sidebar-right").removeClass("toggled");
                }
            });
            $("#menu-toggle-2").click(function (e) {
                e.preventDefault();
                if (localStorage.getItem("menu_small") == '1') {
                    window.localStorage.setItem("menu_small", '0');
                    $(".app-sidebar-right").removeClass("toggled-2");
                } else {
                    window.localStorage.setItem("menu_small", '1');
                    $(".app-sidebar-right").addClass("toggled-2");
                }
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });

            $('.menu').mouseenter(function () {
                if (localStorage.getItem("menu_small") == '1') {
                    $('.opensidebar').hide();
                    $('.closesidebar').show();
                    $('.menu').removeClass('menusmall');
                    $('.sidemenu li a span,.legal').removeClass('displaynone');
                    $('.sidemenu li a i').removeClass('displayicons');
                    $('.sidebar').css({width: "260px"});
                    $('.content').css({marginLeft: "260px"});
                }
            });
            $('.menu').mouseleave(function () {
                if (localStorage.getItem("menu_small") == '1') {
                    $('.opensidebar').show();
                    $('.closesidebar').hide();
                    $('.menu').addClass('menusmall');
                    $('.sidemenu li a span,.legal').addClass('displaynone');
                    $('.sidemenu li a i').addClass('displayicons');
                    $('.sidebar').css({width: "70px"});
                    $('.content').css({marginLeft: "70px"});
                }
            });
            $('.footer-main').show();
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            //Textare auto growth
            //autosize($('textarea.auto-growth'));


        },
        methods: {
            getPermissions: function () {
                //console.log('menu getPermissions');
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.menucustomers = false;
                        self.menucontacts = false;
                        self.menutasks = false;
                        self.menuresale = false;
                        self.menuresalereason = false;
                        self.menucalls = false;
                        self.menucases = false;
                        self.menudunningnotices = false;
                        self.menudunningnotice = false;
                        self.menuwelcomeletter = false;
                        self.menuemployee = false;
                        self.menucollector = false;
                        self.menujob = false;
                        self.menuemail = false;
                        self.menubusinessunits = false;
                        self.menurole = false;
                        self.menucontactrequest = false;
                        self.menuemailbounce = false;
                        self.menucustomersummary = false;
                        self.menucustomersummarydoc = false;
                        if (data.status == 'success') {
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_customer_list') {
                                        self.menucustomers = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_contact_list') {
                                        self.menucontacts = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_task_list') {
                                        self.menutasks = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_resale_list') {
                                        self.menuresale = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_resale_reason_list') {
                                        self.menuresalereason = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_calls_list') {
                                        self.menucalls = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_case_list') {
                                        self.menucases = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_dunning_notice_list') {
                                        self.menudunningnotices = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_dunning_notice_list') {
                                        self.menudunningnotice = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_welcome_letter_list') {
                                        self.menuwelcomeletter = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_employee_list') {
                                        self.menuemployee = true;
                                    }
                                    if (self.permissions[i].name == 'can_access_collector_settings') {
                                        self.menucollector = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_jobs_list') {
                                        self.menujob = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_email_history_list') {
                                        self.menuemail = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_business_unit_list') {
                                        self.menubusinessunits = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_roles_list') {
                                        self.menurole = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_contact_request_list') {
                                        self.menucontactrequest = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_email_bounce_list') {
                                        self.menuemailbounce = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_customer_summary_list') {
                                        self.menucustomersummary = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_customer_summary_doc_list') {
                                        self.menucustomersummarydoc = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/partials/FrontMenu.vue